import styled, { css } from 'styled-components';

const bannerContainerStyles = css`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  @media (min-width: 769px) {
    max-width: 1132px;
    border-radius: 12px;
  }
`;

const BannerStyle = styled.div<{ $overlay?: string }>`
  ${bannerContainerStyles}
  aspect-ratio: 1132 / 220;
  border-radius: 8px;
  cursor: pointer;
  overflow: hidden;

  ${(props) =>
    props.$overlay &&
    css`
      &:after {
        content: '';
        position: absolute;
        background-image: url('${props.$overlay}');
        background-repeat: no-repeat;
        background-size: contain;
        width: clamp(220px, 48%, 550px);
        aspect-ratio: 1423 / 367;
        top: 50%;
        left: 30%;
        transform: translate(-50%, -50%);

        z-index: 1;
      }
    `}

  @media (max-width: 768px) {
    aspect-ratio: 640 / 440;
    border-radius: 0;
    margin-top: 0;

    &:after {
      display: none;
    }
  }
`;

export { BannerStyle };
